import { NavLink } from 'react-router';
import clsx from 'clsx';
import { Compass, Plus, UserRound, type LucideIcon } from 'lucide-react';
import { useT } from '@/lib/i18n';

const TABS: { to: string; icon: LucideIcon; label: string; main?: boolean }[] = [
  { to: '/', icon: Compass, label: 'nav.discover' },
  { to: '/create', icon: Plus, label: 'nav.create', main: true },
  { to: '/me', icon: UserRound, label: 'nav.me' },
];

// Phone-style bottom tabs: Discover · Create · Me (hidden on wide screens, where the header has the links).
export function TabBar() {
  const { t } = useT();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 border-t border-black/5 bg-white/92 pb-[env(safe-area-inset-bottom)] backdrop-blur-md sm:hidden">
      <ul className="mx-auto grid max-w-[560px] grid-cols-3">
        {TABS.map(({ to, icon: Icon, label, main }) => (
          <li key={to}>
            <NavLink to={to} end className={({ isActive }) => clsx('flex flex-col items-center gap-0.5 py-1.5 text-[11px] font-semibold', isActive ? 'text-ink' : 'text-muted')}>
              {main ? (
                <span className="grid size-8 place-items-center rounded-full bg-[linear-gradient(135deg,#c2185b,#e4572e_55%,#f2a900)] text-white shadow-brand"><Icon className="size-5" /></span>
              ) : (
                <Icon className="size-5" />
              )}
              {t(label)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
